import { SETTINGS_FRAGMENT, USER_FRAGMENT } from './queries';

export const LOGIN_MUTATION = `mutation ($type: UserType!,$email:String!,$token:String!){
  login(type:$type,email:$email,token:$token){
    user{
      ...User  
    }
    auth{
    token
    }
  }
}
${USER_FRAGMENT()}
`;

export const LOGOUT_MUTATION = `mutation {
  logout
}`;

export const RESET_PASSWORD_REQUEST_MUTATION = `mutation ($type: UserType!,$email:String!,$recaptchaToken:String!) {
requestResetPassword(
type: $type
email:$email
recaptchaToken:$recaptchaToken
)
}`;
export const RESET_PASSWORD_MUTATION = `
  mutation ($tokenId: ID!, $userId: ID!, $password: String!, $email: String) {
    resetPasswordAndEmail(tokenId: $tokenId, userId: $userId, newPassword: $password, email: $email) {
      user {
        ...User
      }
      auth {
        token
      }
    }
  }
  ${USER_FRAGMENT()}
`;

export const CREATE_ADVISOR_MUTATION = `mutation ($email: String!
$firstName: String!
$lastName: String!
$password: String!
$company: String!
$title: String
$phone: String
$preferredLanguage: AdvisorLanguage
$bookingUrl: String) {
    createAdvisor(email: $email
    firstName: $firstName
    lastName: $lastName
    password: $password
    company: $company
    title: $title
    phone: $phone
    preferredLanguage: $preferredLanguage
    bookingUrl: $bookingUrl
    ) {
        firstName
        lastName
        company
        title
        phone
        email
        preferredLanguage
        bookingUrl
    }
}`;

export const DELETE_ADVISOR_MUTATION = `mutation ($id: ID!) {
    deleteAdvisor(id: $id)
}`;

export const UPDATE_ADVISOR_DETAIL_MUTATION = `mutation ($id: ID!
$firstName: String
$lastName: String
$company: String
$title: String
$phone: String
$preferredLanguage: AdvisorLanguage
$bookingUrl: String) {
    updateAdvisorDetail(id: $id
    firstName: $firstName
    lastName: $lastName
    company: $company
    title: $title
    phone: $phone
    preferredLanguage: $preferredLanguage
    bookingUrl: $bookingUrl) {
        id
        firstName
        lastName
        company
        title
        phone
        preferredLanguage
        bookingUrl
    }
}`;

export const CREATE_MANAGER_MUTATION = `mutation ($email: String!
$name: String!) {
    createManager(email: $email
    name: $name
    ) {
        id
        name
        email
        role
    }
}`;

export const ASSIGN_MANAGER_MUTATION = `mutation ($managerId: ID!
$orgId: ID!) {
    assignManager(managerId: $managerId
    orgId: $orgId
    ) {
        id
        name
    }
}`;

export const CREATE_CLIENT_ORG_MUTATION = `mutation($input: CreateOrganizationInput!) {
  createClientOrganization(input: $input) {
      id
      name
  }
}`;

export const UPDATE_SETTINGS_MUTATION = `mutation(
$input: SettingsInput!
) {
    updateSettings(
        input:$input
) {
        ...settings
    }
}
${SETTINGS_FRAGMENT}
`;

export const ADD_CLIENT_TO_ORG_MUTATION = `
mutation(
$org: ID!
$role:ClientRole
$phone:String
$email: String!
$firstName: String!
$lastName: String!
) {
    addClientToOrg(
    org: $org
    role:$role
    phone:$phone
    email: $email
    firstName: $firstName
    lastName: $lastName
) {
        id
        firstName
        lastName
        phone
        role
        email
    }
}
`;

export const DELETE_CLIENTS_FROM_ORG_MUTATION = `
  mutation DeleteClientsFromOrganization ($orgId: ID!, $clients: [ID!]) {
    deleteClientsFromOrg(orgId: $orgId, clients: $clients)
  }
`;

export const INVITE_CLIENT = `
  mutation ($orgId: ID!, $clientIds: [ID!]!) {
    sendInviteEmails(orgId: $orgId, clientIds: $clientIds)
  }
`;

export const ADD_BULK_CLIENT_TO_ORG_MUTATION = `
mutation(
$input: [ClientImportInput!]!,
$org_id: ID
) {
    bulkImportClients(
    input: $input,
    org_id: $org_id
) {
        id
        firstName
        lastName
        phone
        role
        email
    }
}
`;

export const ASSIGN_ADVISOR_TO_CLIENT_MUTATION = `
mutation(
$clientId:ID!
$advisorId:ID!
) {
    assignAdvisorToClient(
        clientId: $clientId
        advisorId: $advisorId
    ) {
            id
            email
            firstName
            lastName
    }
}`;

export const DELETE_ORGANIZATION_MUTATION = `
mutation ($id: ID!)  {
    deleteOrganization(id: $id)
  }
`;

export const UPDATE_ORGANIZATION_FEATURE_MUTATION = `
mutation ($organizationFeature: OrganizationFeatureInput!) {
  updateOrganizationFeature(organizationFeature: $organizationFeature) {
    id
    type
    enabledAt
    disabledAt
    feature {
      id
      name
      featureFlagKey
      description
    }
  }
}
`;

export const UPDATE_CLIENT_ORGANIZATION_MUTATION = `
mutation(
    $id: ID!
    $name: String
    $status: String
    $managerId:ID
    $advisorId: ID
    $isTcrOnly: Boolean
    $isTcrActive: Boolean
    $isPayingCustomer: Boolean
) {
    updateClientOrganization(
        id: $id,
        name: $name
        status: $status
        advisorId: $advisorId
        managerId: $managerId
        isTcrOnly: $isTcrOnly
        isTcrActive: $isTcrActive
        isPayingCustomer: $isPayingCustomer
        ) {
            id
            name
            status
            advisor {
                id
            }
            admin {
                id
            }
            isTcrOnly
            isPayingCustomer
        }
}`;

export const CHANGE_ORGANIZATION_PREVIEW_MODE_MUTATION = `
mutation ($organizationId: ID!, $isEnabled: Boolean!) {
    changeOrganizationPreviewMode(organizationId: $organizationId, isEnabled: $isEnabled)
}`;

export const CHANGE_ORGANIZATION_DEMO_EMPLOYEES_MUTATION = `
mutation ($organizationId: ID!, $isEnabled: Boolean!) {
    changeOrganizationDemoEmployees(organizationId: $organizationId, isEnabled: $isEnabled)
}`;

export const CHANGE_ORGANIZATION_ANALYTICS_EVENTS_MUTATION = `
mutation ($organizationId: ID!, $isEnabled: Boolean!) {
    changeOrganizationAnalyticsEvents(organizationId: $organizationId, isEnabled: $isEnabled)
}`;

export const DELETE_ADMIN_MUTATION = `
mutation ($id: ID!)  {
    deleteSuperAdmin(id: $id)
    }
`;

export const UPDATE_ADMIN_MUTATION = `
mutation (
    $id: ID!
    $name: String
    $role: String
)  {
    updateAdmin(id: $id, 
        name: $name,
        role: $role
        ) {
        id
        name
        email
        role
    }
}
`;

export const UPDATE_CLIENT_DETAIL_MUTATION = `
mutation (
    $id: ID!
    $firstName: String
    $lastName: String
    $phone: String
    $role: ClientRole
    $email: String
    $workEmail: String
    $preferredLanguage: ClientLanguage
)  {
    updateClientDetail(id: $id, 
        firstName: $firstName,
        lastName: $lastName,
        phone: $phone,
        role: $role
        email: $email
        workEmail: $workEmail
        preferredLanguage: $preferredLanguage
    ) {
        id
        firstName
        lastName
        phone
        role
        email
        workEmail
        preferredLanguage
    }
}
`;

export const UPDATE_CLIENT_EMAIL_MUTATION = `
mutation (
    $id: ID!
    $email: String!
)  {
    updateClientEmail(id: $id, 
        email: $email
        ) {
        updated
        message
    }
}
`;

export const CANCEL_ORG_SUBSCRIPTION_MUTATION = `
mutation ($orgId: ID!) {
    cancelOrgSubscription(orgId: $orgId) {
      success
      subscriptionStatus
    }
}
`;

export const RESTORE_ORG_SUBSCRIPTION_MUTATION = `
mutation ($orgId: ID!) {
    restoreOrgSubscription(orgId: $orgId) {
        success
        subscriptionStatus
        nextRenewalDate
    }
}
`;

export const REACTIVATE_ORG_SUBSCRIPTION_MUTATION = `
mutation ($orgId: ID!) {
    reactivateOrgSubscription(orgId: $orgId) {
        success
        subscriptionStatus
    }
}
`;

export const MANUAL_PAY_INVOICE_MUTATION = `
mutation ($input: ManualPayInvoiceInput!) {
    manualPayInvoice(input: $input) {
      success
      invoiceId
      invoiceStatus
      message
    }
}
`;

export const CREATE_INVOICE_PREVIEW = `
mutation ($orgId: ID!) {
    createInvoicePreview(orgId: $orgId)
}
`;

export const MARK_INVOICE_AS_PAID_MUTATION = `
mutation ($input: MarkInvoiceAsPaidInput!) {
    markInvoiceAsPaid(input: $input) {
      success
      invoiceId
      invoiceStatus
      message
    }
}
`;

export const CREATE_DISCOUNT_CODE_MUTATION = `
mutation ($input: CreateDiscountCodeInput!) {
    createDiscountCode(input: $input) {
        success
        discountCode {
            id
            name
            code
            discountPercentage
            maxRedemptions
            timesRedeemed
            active
        }
    }
}
`;

export const DELETE_DISCOUNT_CODE_MUTATION = `
mutation ($promotionCodeId: ID!) {
    deleteDiscountCode(promotionCodeId: $promotionCodeId) {
        success
        message
    }
}
`;

export const APPLY_DISCOUNT_CODE_TO_ORG_MUTATION = `
mutation ($input: ApplyDiscountCodeInput!) {
    applyDiscountCodeToOrganization(input: $input) {
        success
        message
        promotionCodeId
        couponId
        code
    }
}
`;

export const REMOVE_DISCOUNT_CODE_FROM_ORG_MUTATION = `
mutation ($input: RemoveDiscountCodeInput!) {
    removeDiscountCodeFromOrganization(input: $input) {
        success
        message
    }
}
`;

export const UPGRADE_PLAN_MUTATION = `
mutation ($orgId: ID!, $input: UpgradePlanInput!) {
    upgradeOrgPlan(orgId: $orgId, input: $input) {
        success
    }
}
`;

export const DOWNGRADE_PLAN_MUTATION = `
mutation ($orgId: ID!, $input: DowngradePlanInput!) {
    downgradeOrgPlan(orgId: $orgId, input: $input) {
        success
    }
}
`;

export const CANCEL_DOWNGRADE_ORG_PLAN_MUTATION = `
mutation ($orgId: ID!) {
    cancelDowngradeOrgPlan(orgId: $orgId) {
        success
    }
}
`;

export const SAVE_CUSTOM_PRICES_MUTATION = `
mutation ($orgId: ID!, $inputs: [SaveCustomPriceInput!]!) {
    saveCustomPrices(orgId: $orgId, inputs: $inputs) {
        id
        operation
        success
        message
    }
}
`;

export const DELETE_CUSTOM_PRICE_MUTATION = `
mutation DeleteCustomPrice($id: ID!, $orgId: ID) {
  deleteCustomPrice(id: $id, orgId: $orgId)
}
`;

export const SAVE_ORGANIZATION_BILLING_DETAILS_MUTATION = `
  mutation SaveOrganizationBillingDetails($orgId: ID!, $input: UpdateOrganizationBillingInput!) {
    saveOrganizationBillingDetails(orgId: $orgId, input: $input) {
      success
      message
    }
  }
`;

export const CREATE_STRIPE_CUSTOMER_MUTATION = `
  mutation CreateStripeCustomer($orgId: ID!) {
    createStripeCustomer(orgId: $orgId) {
      customerId
      created
    }
  }
`;

/** TwoFactorAuthResponse: success, code (optional), createdAt */
export const TWO_FACTOR_AUTH_RESPONSE_FIELDS = 'success\n  code\n  createdAt';

export const SUPERADMIN_SET_2FA_PHONE_MUTATION = `
  mutation ($token: String!, $phone: String!, $phoneCountryCode: PhoneCountryCodeEnum!) {
    superadminSet2FAPhone(token: $token, phone: $phone, phoneCountryCode: $phoneCountryCode) {
      ${TWO_FACTOR_AUTH_RESPONSE_FIELDS}
    }
  }
`;

/** Token-based send (email from token). Returns TwoFactorAuthResponse. */
export const SEND_2FA_CODE_TOKEN_MUTATION = `
  mutation ($type: UserType!, $token: String!) {
    send2faCode(type: $type, token: $token) {
      success
      code
      createdAt
    }
  }
`;

/** Token-based verify. Returns Boolean. */
export const VERIFY_2FA_CODE_TOKEN_MUTATION = `
  mutation ($type: UserType!, $token: String!, $code: String!) {
    verify2faCode(type: $type, token: $token, code: $code)
  }
`;

export const VALIDATE_REAUTH_CODE_MUTATION = `
  mutation ($otpCode: String!) {
    validateReauthCode(otpCode: $otpCode)
  }
`;

export const RESEND_REAUTH_CODE_MUTATION = `
  mutation {
    resendReauthCode {
      otpCode
      success
    }
  }
`;

/** SuperAdmin: request phone change; sends 6-digit code to new number. Session-based. */
export const REQUEST_PHONE_CHANGE_MUTATION = `
  mutation ($phone: String!, $phoneCountryCode: PhoneCountryCodeEnum!) {
    requestPhoneChange(phone: $phone, phoneCountryCode: $phoneCountryCode)
  }
`;

/** SuperAdmin: verify code and apply phone + profile. Requires pending phone change. */
export const VERIFY_PHONE_CHANGE_MUTATION = `
  mutation ($input: VerifyPhoneChangeInput!) {
    verifyPhoneChange(input: $input)
  }
`;

/** SuperAdmin: resend verification code to the given number. Session-based. */
export const RESEND_PHONE_CHANGE_CODE_MUTATION = `
  mutation ($phone: String!, $phoneCountryCode: PhoneCountryCodeEnum!) {
    resendPhoneChangeCode(phone: $phone, phoneCountryCode: $phoneCountryCode)
  }
`;

export const EXPORT_GLOBAL_ACTIVITY_LOG_MUTATION = `mutation ($filter: ActivityLogFilterInput!, $sort: ActivityLogSortInput) {
  exportGlobalActivityLog(filter: $filter, sort: $sort) {
    total
    rows {
      timestampUtc
      administratorName
      administratorEmail
      organizationId
      organizationName
      action
      actionLabel
      targetType
      targetId
      targetLabel
    }
  }
}`;
